var _line, _line2, _line3, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalRou = function SvgPSignalRou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 470.1,
    y1: 55.1,
    x2: 470.1,
    y2: 46.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 506.1,
    y1: 55.1,
    x2: 506.1,
    y2: 46.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 542.1,
    y1: 55.1,
    x2: 542.1,
    y2: 46.1,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "578.1,46.1 578.1,55.1 342.1,55.1 342.1,46.1",
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPSignalRou;